<script lang="ts">
  import {
    DEFAULT_STANDALONE_PROMPTS_POSITION,
    getPositionStyle,
  } from "website_script/lib/widgetPosition"
  import type { Settings } from "website_script/types/settings"
  import { getContext, onMount } from "svelte"
  import { getTopPrompt } from "website_script/lib/widgetPrompts"
  import WidgetPopover from "../components/WidgetPopover.svelte"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"

  let popover: WidgetPopover
  let isPromptShown: boolean = false

  const { enableStandalonePrompts, standalonePromptsConfig } =
    getContext<Settings>("settings")

  const widgetPosition =
    standalonePromptsConfig.position || DEFAULT_STANDALONE_PROMPTS_POSITION
  const positionStyle = getPositionStyle(widgetPosition)

  const { buttonConfig, promptConfig } = getTopPrompt(
    standalonePromptsConfig.prompts || [],
    standalonePromptsConfig.buttons
  )

  $: floatingRef = popover ? popover.getPopoverInstance().floatingRef : () => {}

  onMount(() => {
    const timeout = setTimeout(() => {
      isPromptShown = true
    }, (standalonePromptsConfig.promptDelay ?? 0) * 1000)

    return () => {
      clearTimeout(timeout)
    }
  })
</script>

{#if enableStandalonePrompts}
  {#if popover}
    <div
      class="au-standalone-prompts"
      data-testid="standalone-prompts-anchor"
      style={positionStyle}
      use:floatingRef
    />
  {/if}

  {#if buttonConfig && promptConfig && isPromptShown}
    <WidgetPopover
      showArrow={false}
      integrationType={IntegrationTypes.STANDALONE_PROMPTS}
      bind:this={popover}
      {buttonConfig}
      {promptConfig}
      {widgetPosition}
    />
  {/if}
{/if}

<style>
  .au-standalone-prompts {
    z-index: var(--au-z-index-widget);
    position: fixed;
    background-color: transparent;
    width: 1px;
    height: 1px;
  }
</style>
